import React from 'react';

export const HiddenHeader: React.FC = () => {
  return null;
};
